import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appUserChange]',
})
export class UserChangeDirective {
  private isUserInitiated = false;

  @HostListener('click', ['$event'])
  onClick() {
    this.isUserInitiated = true;
  }

  @HostListener('keyup', ['$event'])
  onKeyUp() {
    this.isUserInitiated = true;
  }

  isUserChange(): boolean {
    const wasUserInitiated = this.isUserInitiated;
    this.isUserInitiated = false; // Reset after checking
    return wasUserInitiated;
  }
}
